/* 
 * Click nbfs://nbhost/SystemFileSystem/Templates/Licenses/license-default.txt to change this license
 * Click nbfs://nbhost/SystemFileSystem/Templates/ClientSide/javascript.js to edit this template
 */


import { useState, useEffect }
    from "react";
import { useParams, useLocation }
    from 'react-router-dom';

import { Container, Row, Col, Tab, Nav }
    from 'react-bootstrap';
import { library }
    from '@fortawesome/fontawesome-svg-core';
import { fas }
    from '@fortawesome/free-solid-svg-icons';
import { fab }
    from '@fortawesome/free-brands-svg-icons';
import { far }
    from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon }
    from '@fortawesome/react-fontawesome';

library.add(fas, fab, far);
function AboutUs() {

    return (
        <Tab.Container id="left-tabs-example" defaultActiveKey="about">
            <Row>
                <Col sm={3}>
                    <Nav variant="pills" className="flex-column">
                        <Nav.Item>
                            <Nav.Link eventKey="about">About us</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="vision">Our Vision & Purpose</Nav.Link>
                        </Nav.Item>
                        {/* <Nav.Item>
                            <Nav.Link eventKey="quality">Quality Standards</Nav.Link>
                        </Nav.Item> */}
                    </Nav>
                </Col>
                <Col sm={9}>
                    <Tab.Content>
                        <Tab.Pane eventKey="about">
                            <b>GRACE SUPERMARKET</b><br />
                            Mr. M. Selvaraj, the visionary founder of Grace Supermarket, began a modest retail venture in 1972 in Nungambakkam, Chennai, the capital city of Tamil Nadu. Over time, the reins of the business were passed to his son, Mr. S. Rajakumar, who recognized the immense potential in the evolving supermarket industry. Under his leadership, Our Supermarket inaugurated its first modern-format supermarket in Vadapalani in 1999, marking a pivotal milestone for the organization.<br /><br />

                            Under Mr. S. Rajakumar’s stewardship, Grace Supermarket experienced significant growth, establishing itself as a prominent and trusted player in the retail sector. The company’s core strategy has always focused on offering customers a wide selection of first-quality merchandise, value for money, and exceptional service — a philosophy that has guided its long-standing success.<br /><br />

                            On 3 October 2022, Grace Supermarket entered a new chapter by transitioning from a proprietorship to a private limited company, officially becoming M/s. Grace Mart Private Limited (GMPL). Following this transformation, Mr. Jeya Godwin Rajakumar, son of Mr. S. Rajakumar, joined the company. He currently leads the Marketing and Branding division, bringing a fresh vision aimed at elevating the company into a fully modernized retail brand.<br /><br />

                            As of today, Grace Mart Private Limited operates 40+ successful supermarket stores across Chennai, covering a total of 200,000 square feet of retail space. This consistent growth is a direct result of the company’s dedication to product research, quality assurance, competitive pricing, and superior customer service.<br /><br />
                            To enhance customer convenience and reach, GMPL launched its online platform, Grace Daily, delivering a seamless digital shopping experience and swift doorstep service to a wider audience.<br /><br />

                            <b>At the heart of GMPL’s operational philosophy lies a simple yet impactful principle:</b>
                            <i>“ Reduce costs and pass on the savings to customers.”</i>
                            This, combined with the purchasing power of its extensive customer base — serving approximately 12.37 million customers annually — allows the company to offer competitive pricing without compromising on quality.<br /><br />
                            In 2016, the company achieved another milestone by establishing a state-of-the-art, 1,50,000 sq. ft. warehouse in Chennai. This facility centralized the supply chain, streamlined logistics and enabled faster, more efficient distribution across all stores.<br /><br />
                            As Grace Mart Private Limited continues to evolve, its unwavering commitment to product quality, customer satisfaction and operational excellence remains at the core of its values. Each product is carefully curated based on quality, price, brand reputation and usability.<br /><br />
                            Driven by a legacy of entrepreneurship and a future-focused mindset, Grace Mart Private Limited is committed to exceeding customer expectations at every level. From top management to store and warehouse teams, every member of the organization shares a unified vision of delivering unmatched service.<br /><br />
                            With determination, innovation and customer loyalty, Grace Mart’s journey of success continues to unfold — one step ahead in modern retail.<br /><br />


                        </Tab.Pane>
                        <Tab.Pane eventKey="vision">
                            <b>Our Vision</b><br />
                            <b>To be India’s trailblazing omni-channel gourmet destination — redefining the way the nation experiences food.</b><br /><br />

                            We’re on a mission to bring India’s freshest, finest, and most flavourful  food to every doorstep — from bustling metros to emerging tier-I cities.<br />

                            •	Expanding horizons with premium stores in key cities and seamless nationwide reach through our E/M-commerce platforms.<br /><br />
                            •	Curating joy with an exceptional range of local and global gourmet delights.<br /><br />
                            •	Delivering delight with unmatched service and unforgettable customer experiences.<br /><br />
                            •	Setting the standard in gourmet food retail — and raising it year after year.<br /><br />
                            <b>Our purpose</b><br /><br />
                            To spread the joy of food — one fresh, delicious bite at a time.<br /><br /><br />
                            <b>Our Commitment</b><br /><br />
                            At Grace Supermarket, we go the extra mile so you can shop with confidence. Quality is at the core of everything we do — because you deserve nothing but the best.<br />
                        </Tab.Pane>
                        <Tab.Pane eventKey="quality">
                            <b>Grace Supermarket – Quality Policy</b><br />
                            At Grace Supermarket, quality is not just a promise — it’s our identity. Every product, service, and interaction reflects our commitment to excellence. We follow strict quality protocols to ensure that our customers receive only the best, every single day.<br /><br />

                            <b>🔹1. Premium A+ Quality Only</b><br />
                            •	We stock only top-tier fresh produce and bakery products.<br />
                            •	Our sourcing teams select only the finest fruits, vegetables, and ingredients to meet our strict internal benchmarks.<br />
                            •	All bakery items are prepared to meet our highest quality standards.<br /><br />


                            <b>🔹2. Freshness Delivered Daily</b><br />
                            •	Daily procurement ensures our shelves are stocked with fresh produce and bakery goods every morning.<br />
                            •	Products left over from the previous day are either discarded or returned to be routed through alternate channels.<br />
                            •	Our customers always get to choose from a fresh and wide variety.
                            <br /><br />

                            <b>🔹3. Best-in-Class Storage Practices</b><br />
                            •	We maintain ideal temperatures for all products by keeping refrigeration and freezer units running 24/7.<br />
                            •	Exhaust fans are used at night to maintain air circulation for ambient goods.<br />
                            •	While this increases operational costs, we believe in doing what’s necessary to ensure product safety and freshness.<br /><br />


                            <b>🔹4. Ethical and Trusted Vendors Only</b><br />
                            •	We work exclusively with ethically compliant and reputed suppliers.<br />
                            •	No grey market dealings or tolerance for tampering with sell-by dates.<br />
                            •	If a vendor is found compromising product safety, their contracts are immediately terminated.
                            <br /><br />

                            <b>🔹5. Monthly Expiry Checks</b><br />
                            •	Our team conducts monthly audits of all branded products for expiry.<br />
                            •	Items near expiry are returned to vendors or discarded, never sold to our customers.<br /><br />


                            <b>🔹 6. Hygiene and Handling Standards</b><br />
                            •	All staff handling food wear gloves and hairnets at all times.<br />
                            •	Stores are sanitized regularly using food-grade cleaning agents.<br />
                            •	Food storage and display units are cleaned as per a strict sanitation schedule.<br /><br />


                            <b>🔹 7. Customer-First Return Policy</b><br />
                            •	If a product is found to be expired or spoiled, we offer an easy replacement, exchange, or full refund — no questions asked.<br /><br />

                        </Tab.Pane>
                    </Tab.Content>
                </Col>
            </Row>
        </Tab.Container>
    );
}

export default AboutUs;